<template lang="pug">
  div
    .parallax 
    v-container()
      v-row(justify="center")
        v-col(cols="12" md="4" align="center")
          .title.mb-1 Art & Music Images
          div(style="max-width:500px")            
            v-carousel(cycle hide-delimiter-background delimiter-icon="mdi-circle-medium"  show-arrows-on-hover width="450" height="300"  )
              v-carousel-item(v-for="(photo,i) in photos" :key="i" :src="photo", 'reverse-transition'="fade-transition" transition="fade-transition")
        v-col(cols="12" md="8")
          p.headline About Us
          p.body-1 The Youth Department aims to engage youth and young adults in church by supporting and creating youth-based initiatives, programs, and/or events at the church. We aim to recruit and retain new youth and  young adult members through outreach and revivals. Most of all, we want to share and teach the love and word of God. We plan to do this through inspiration and not indoctrination.
        v-col(cols="12") 
          p.title Current Projects
          p.body-1 Our department's ministry is delegated in several sections:
          ul
            li Children ages 5-12
            li Youth ages 13-17
            li Young Adults ages 18-25
          .title Contact
          p.body-1 You may email us at 
            a(:href="mailTo" target="_blank" )
              span.theEmail.pb-1 coruccyouthteam@gmail.com
            | :
          .title Leaders:
          p.body
            |      Pastor Ernest Larkins
            br
            |      Lay Pastor Tina Stewart-Taylor
            br
            |      Lay Pastor RJ Ulmer
          p.headline.mt6 We meet every 3rd and 4th Sunday before service.
</template>

<script>
export default {
  computed: {
    mailTo() {
      return 'mailto:' + 'coruccyouthteam@gmail.com';
    }
  },
  data() {
    return {
      photos: [
        {
          src: require('../../assets/img/youth/1019312.jpg')
        },
        {
          src: require('../../assets/img/youth/352091.jpg')
        },
        {
          src: require('../../assets/img/youth/3722499.jpg')
        },
        {
          src: require('../../assets/img/youth/4383478.jpg')
        },
        {
          src: require('../../assets/img/youth/6087369.jpg')
        },
        {
          src: require('../../assets/img/youth/7057054.jpg')
        },
        {
          src: require('../../assets/img/youth/7311901.jpg')
        },
        {
          src: require('../../assets/img/youth/7740407.jpg')
        }
      ]
    };
  }
};
</script>

<style lang="stylus" scoped>
.parallax
  background-image url('../../assets/img/3922713_orig.png')
  background-size 60% 40%
  height 300px
  background-color #751A00
  background-attachment fixed
  background-position center
  background-repeat no-repeat
  color white

.body-1 a
  text-decoration none

.theEmail
  text-decoration none
  border-bottom 1px solid #000000
  color var(--v-primary-darken2)

.theEmail:hover
  border-bottom 1px solid rgba(0, 0, 0, 0)
  color var(--v-info-darken2)
</style>
